import { useEffect } from 'react';
const isInAppBrowser = () => {
    const ua = navigator.userAgent || '';
    return /FBAN|FBAV|Instagram/.test(ua);
};
export default function useExternalScripts() {
    useEffect(() => {
        if (isInAppBrowser()) {
            console.warn('External scripts disabled in In-App Browser');
            return;
        }
        const environment = process.env.ENVIRONMENT;
        const gtmIds = environment === 'PROD'
            ? ['GTM-T8H93QTG', 'GTM-NMKNNVM']
            : ['GTM-PFV7RXH6'];
        const fbPixelId = environment === 'PROD'
            ? '102441836939646'
            : '677292665283286';
        const head = document.head;
        const body = document.body;
        if (!head || !body)
            return;
        const scripts = [];
        const loadGTMAndPixel = () => {
            // ---------- GTM ----------
            gtmIds.forEach((gtmId) => {
                const gtmScript = document.createElement('script');
                gtmScript.async = true;
                gtmScript.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');
        `;
                head.appendChild(gtmScript);
                scripts.push(gtmScript);
            });
            // ---------- FB PIXEL ----------
            const fbPixelScript = document.createElement('script');
            fbPixelScript.async = true;
            fbPixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${fbPixelId}');
        fbq('track', 'PageView');
      `;
            head.appendChild(fbPixelScript);
            scripts.push(fbPixelScript);
        };
        const timer = setTimeout(loadGTMAndPixel, 3000);
        return () => {
            clearTimeout(timer);
            scripts.forEach((script) => {
                script.parentNode?.removeChild(script);
            });
        };
    }, []);
}
